import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DisabledUserComponent } from './components/disabled-user/disabled-user.component';
import { PrivateLayoutComponent } from './components/layout/private-layout.component';
import { RoutePages } from './enum/route-pages.enum';
import { AuthGuard } from './guards/auth.guard';
import { AuthComponent } from './pages/auth/auth/auth.component';
import { ChangePasswordComponent } from './pages/auth/login/change-password/change-password.component';
import { ForgetPasswordComponent } from './pages/auth/login/forget-password/forget-password.component';
import { ResetPasswordComponent } from './pages/auth/reset-password/reset-password.component';
import { ExternalProposalComponent } from './pages/proposal/external-proposal/external-proposal.component';

const routes: Routes = [
  { path: RoutePages.Login, component: AuthComponent },
  { path: RoutePages.RecoverPassword, component: ForgetPasswordComponent },
  {
    path: RoutePages.SignUp,
    loadChildren: () =>
      import(`./modules/signup.module`).then((m) => m.SignupModule),
  },
  {
    path: RoutePages.ChangePassword + '/:id',
    component: ChangePasswordComponent,
  },
  { path: RoutePages.ResetPassword, component: ResetPasswordComponent },
  {
    path: RoutePages.ExternalProposal + '/:id',
    component: ExternalProposalComponent,
  },
  {
    path: RoutePages.SettingsInitial,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(`./modules/settings.module`).then((m) => m.SettingModule),
  },
  {
    path: '',
    component: PrivateLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: RoutePages.Dashboard,
        pathMatch: 'full',
      },
      {
        path: RoutePages.Validation,
        component: DisabledUserComponent,
      },
      {
        path: RoutePages.Dashboard,
        loadChildren: () =>
          import(`./modules/dashboard.module`).then((m) => m.DashboardModule),
      },
      {
        path: RoutePages.Financial,
        loadChildren: () =>
          import(`./modules/financial.module`).then((m) => m.FinancialModule),
      },
      {
        path: RoutePages.Settings,
        loadChildren: () =>
          import(`./modules/settings.module`).then((m) => m.SettingModule),
      },
      {
        path: RoutePages.Quotes,
        loadChildren: () =>
          import(`./modules/quotation.module`).then((m) => m.QuotationModule),
      },
      {
        path: RoutePages.Proposals,
        loadChildren: () =>
          import(`./modules/proposal.module`).then((m) => m.ProposalModule),
      },
      {
        path: RoutePages.ManagementUsers,
        loadChildren: () =>
          import(`./modules/management-users.module`).then(
            (m) => m.ManagementUsersModule
          ),
      },
      /*
    Módulo de Operações
  {
    path: RoutePages.CreditOperation,
    loadChildren: () =>
      import(`./modules/operation.module`).then((m) => m.CreditOperationModule),
    canActivate: [AuthGuard],
  },
  */
    ],
  },
  { path: '**', redirectTo: '/login', pathMatch: 'full' },
];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
